import React from 'react';
import Icon from '@pushpay/icon';

const ClockIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10-.007-5.52-4.48-9.993-10-10zm0 18.333a8.333 8.333 0 110-16.666A8.333 8.333 0 0120.333 12 8.343 8.343 0 0112 20.333zm4.278-5.158l-3.861-3.54V7.416a.834.834 0 00-1.667 0V12c0 .234.098.457.27.615l4.133 3.787a.841.841 0 001.177-.05.833.833 0 00-.052-1.177z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

export default ClockIcon;